module.exports = __webpack_public_path__ + "labioplastika_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_2_before.jpg
// module id = 1070
// module chunks = 0